module.exports = __webpack_public_path__ + "img/casino-2.94a056ef.png";